import {typeAffirmer,validate_object,freeze, get_default} from '../mixins.js';  
import {compose} from '../supports.js';

/**
 * @desc each property includes
 * @param {any} default - default value to be assigned if no value provided.
 * @param {Function} test - test if assigned value is correct. 
 *                        - expects @return true if value is passed.
 *                        - expects @return false if value is incorrect.
 *                        - will throw Error if test fails.   
 *                        - falsy values won't throw error. optional chaining should be avoided. 
 */
let propSettings={
    viewInjected:{
        default:false,
        test:typeAffirmer('boolean')
    },
    initialVolume:{
        default:1,
        test(val){
            return typeAffirmer('number')(val) && (val >= 0) && (val <= 1)
        }
    },
    muteMode:{
        default:false,
        test:typeAffirmer('boolean')
    },
    seekduration:{
        default:10,
        test:typeAffirmer('number')
    },
    vendorId:{
        default: '',
        test:typeAffirmer( 'string' ) 
    },
    widevineLicenseURL:{
        default:'',
        test:typeAffirmer('string')
    },
    fairplayCertificateURL:{
        default:'',
        test:typeAffirmer('string')
    },
    fairplayLicenseURL:{
        default:'',
        test:typeAffirmer('string')
    }
} 
 
let getSettings=compose(freeze,validate_object(propSettings));
let getDefaultSettings=compose(freeze,get_default(propSettings));


export {getSettings,getDefaultSettings};